export default "__VITE_ASSET__DbGOPwmh__"